/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
export type CreatedAtCell_ScheduleFragment = { __typename: 'Schedule', id: string, createdAt: any };

export const CreatedAtCell_ScheduleFragmentDoc = gql`
    fragment CreatedAtCell_schedule on Schedule {
  id
  createdAt
}
    `;